import React from 'react';
import CoinIcon from './CoinIcon';

export default function ExerciseCompleteOverlay({
  type = 'success', // 'success' | 'warning' | 'error'
  exerciseTitle = 'Exercise',
  stars = 0,
  coins = 0,
  message,
  onPrimary,
  onSecondary,
  primaryLabel = 'OK',
  secondaryLabel = 'Return',
}) {
  const colors = {
    success: { bg: '#ecfdf5', border: '#34d399', icon: '✅' },
    warning: { bg: '#fff7ed', border: '#f59e0b', icon: '⚠️' },
    error: { bg: '#fef2f2', border: '#ef4444', icon: '❌' },
  }[type] || { bg: '#ecfdf5', border: '#34d399', icon: '✅' };

  return (
    <div style={{
      position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
      background: 'rgba(15, 23, 42, 0.85)', backdropFilter: 'blur(6px)',
      zIndex: 5000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20
    }}>
      <div style={{
        background: 'white', borderRadius: 20, width: '92%', maxWidth: 520,
        padding: '20px 22px', border: `3px solid ${colors.border}`, boxShadow: '0 15px 40px rgba(0,0,0,0.25)'
      }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10, marginBottom: 8 }}>
          <div style={{ fontSize: 24 }}>{colors.icon}</div>
          <h3 style={{ margin: 0, fontSize: 18, fontWeight: 900, color: '#0f172a' }}>
            {type === 'success' ? 'Congratulations!' : type === 'warning' ? 'Please Review' : 'Save Error'}
          </h3>
        </div>
        <div style={{
          background: colors.bg, border: `2px solid ${colors.border}`, borderRadius: 12,
          padding: '12px 14px', marginBottom: 14
        }}>
          <div style={{ fontWeight: 800, color: '#0f172a', marginBottom: 6 }}>
            {exerciseTitle}
          </div>
          <div style={{ color: '#334155', fontWeight: 700, fontSize: 13, lineHeight: 1.5 }}>
            {message}
          </div>
        </div>
        {type === 'success' && (stars > 0 || coins > 0) && (
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 12, fontWeight: 900, color: '#1e293b' }}>
            {stars > 0 && <span style={{ background: '#d1fae5', color: '#065f46', padding: '6px 10px', borderRadius: 10 }}>⭐ {stars}</span>}
            {coins > 0 && <span style={{ background: '#fef3c7', color: '#92400e', padding: '6px 10px', borderRadius: 10, display: 'inline-flex', alignItems: 'center', gap: 4 }}><CoinIcon size={14} title="" /> {coins}</span>}
          </div>
        )}
        <div style={{ display: 'flex', gap: 10, justifyContent: 'flex-end' }}>
          {type !== 'success' && (
            <button
              onClick={onSecondary}
              style={{ padding: '10px 14px', fontWeight: 800, borderRadius: 12, border: '2px solid #e2e8f0', background: '#f8fafc', color: '#334155', cursor: 'pointer' }}
            >{secondaryLabel}</button>
          )}
          <button
            onClick={onPrimary}
            style={{ padding: '10px 14px', fontWeight: 900, borderRadius: 12, border: 'none', background: '#4361ee', color: 'white', cursor: 'pointer' }}
          >{primaryLabel}</button>
        </div>
      </div>
    </div>
  );
}
